/**
 * Frequently Bought Together — self-contained add-to-cart.
 *
 * Each FBT card wraps its control in <fbt-add data-variant-id="...">. For
 * multi-variant products an inline <select> lets the shopper choose an option
 * ON THE PAGE (no navigation, no modal). On click we POST /cart/add.js and then
 * dispatch the same ThemeBus events product-form.js / quick-buy-button.js use so
 * the cart drawer opens and re-renders. No dependency on <product-card> or
 * <product-form> plumbing.
 */
import { ThemeBus } from "./events-bus.js";
import { EVENTS } from "./event-constants.js";

class FbtAdd extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;
    this.button = this.querySelector("[data-fbt-add]");
    this.select = this.querySelector("select");
    if (this.button) {
      this._onClick = () => this.add();
      this.button.addEventListener("click", this._onClick);
    }
  }

  disconnectedCallback() {
    if (this.button && this._onClick) this.button.removeEventListener("click", this._onClick);
    this._init = false;
  }

  get variantId() {
    if (this.select && this.select.value) return this.select.value;
    return this.getAttribute("data-variant-id");
  }

  async add() {
    if (this._busy || !this.button) return;
    const id = this.variantId;
    if (!id) return;
    this._busy = true;
    const label = this.button.textContent;
    this.button.disabled = true;
    this.button.textContent = "Adding…";
    try {
      const fd = new FormData();
      fd.append("id", id);
      fd.append("quantity", "1");
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: fd,
      });
      const result = await res.json();
      if (result.status && result.status !== 200) {
        this.button.textContent = "Unavailable";
      } else {
        window.__cart = result;
        try { ThemeBus.dispatchEvent(new Event(EVENTS.cartUpdated)); } catch (_) {}
        try { ThemeBus.dispatchEvent(new Event(EVENTS.cartItemAdded)); } catch (_) {}
        this.button.textContent = "Added ✓";
      }
    } catch (err) {
      this.button.textContent = "Try again";
    } finally {
      this._busy = false;
      setTimeout(() => {
        if (!this.button) return;
        this.button.disabled = false;
        this.button.textContent = label || "Add to basket";
      }, 1600);
    }
  }
}

if (!customElements.get("fbt-add")) {
  customElements.define("fbt-add", FbtAdd);
}
